var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.0377312,4.0002532v0.0025067H6.9516077C5.3515511,3.9846842,4.0195184,5.2857757,4,6.8858323v34.2276459 c0.0187931,1.6009483,1.3506522,2.9034653,2.9516077,2.8862877h34.0861244 c1.6048813,0.0202217,2.9414062-1.2821159,2.9628792-2.8862877V6.8835068 C43.9791374,5.2800527,42.6408119,3.9791424,41.0377312,4.0002532z M15.8631248,38.0827904H9.9300489V18.9947987h5.9330759 V38.0827904z M16.3385048,12.9463148c0,1.8864946-1.552269,3.4391432-3.4387808,3.4393244c-0.0003624,0-0.000536,0-0.0007248,0 c-1.886858,0-3.4395056-1.5524664-3.4395056-3.4393244c0-1.8868742,1.5526476-3.4395142,3.4395056-3.4395142 c1.8867006,0,3.4391584,1.5522852,3.4395056,3.438796C16.3385048,12.9457703,16.3385048,12.9459515,16.3385048,12.9463148z  M38.0830803,38.0827904h-5.9269905V28.800909c0-2.2133904-0.0395432-5.0626526-3.0825768-5.0626526 c-3.0870552,0-3.5593929,2.4114532-3.5593929,4.9014435v9.4423733h-5.9268169V18.9947987h5.6897583v2.6084347h0.079792 c1.1584949-1.980793,3.3205357-3.1682663,5.6139069-3.0831051c6.0071449,0,7.1148262,3.9512196,7.1148262,9.091692 L38.0830803,38.0827904z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinMedium);
export default __webpack_public_path__ + "static/media/linkedin--medium.5a1923081324a271afc982a793555ddc.svg";
export { ForwardRef as ReactComponent };